export { default as Create } from './Create';
export { default as Delete } from './Delete';
export { default as Edit } from './Edit';
export { default as Read } from './Read';



// WEBPACK FOOTER //
// ./src/views/Common/Utils/AccessCheck/index.tsx